import type { Post } from '@tribeplatform/gql-client/types'

import type { StaticField } from '../../Views/types'
import { PostsCardItem } from './PostsCardItem'

interface Props {
  posts: Post[]
  fields: StaticField[]
  activeFieldId?: string
  showMoreButton: JSX.Element
  preview: boolean
}
export const PostsCard = ({
  posts,
  fields,
  activeFieldId,
  showMoreButton,
  preview,
}: Props) => {
  return (
    <div className="space-y-5">
      {posts.map(post => (
        <PostsCardItem
          key={post.id}
          post={post}
          fields={fields.filter(
            field =>
              field.enabled &&
              !(field.styles && field.styles.indexOf('card') === -1),
          )}
          activeFieldId={activeFieldId}
          preview={preview}
        />
      ))}
      {showMoreButton}
    </div>
  )
}
